import React from 'react';
import styled from 'styled-components';
import up from '../../assets/up.png';
import Forestfires from '../../components/Forestfires/Forestfires';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;

class CardForestfires extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
              
      <Forestfires/>
      
            
    </Viz>
    <ReusableDetailCard
   trend= {up}
   metricsm="7.0 Million Acres per year"
   diagnosis="Though fires occur naturally in many healthy forest ecosystems, man-made forest fires attributed to land clearing, subsistence farming, and rising temperatures."
   prediction="Forest fires can exacerbate climate change, cause health issues, wreck economic damage, and result in habitat loss."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />

  </Container>
  );
 }
}
export default CardForestfires;

